<template>
  <v-card color="transparent" flat>
    <event-cards
      :events="current"
      :loading="loading"
      :title="title"
    >
      <template v-slot:empty>
        <mailing-list/>
      </template>
    </event-cards>
    <event-cards
      aspect-ratio="1"
      disabled
      :events="past"
      :loading="loading"
      title="Past Events"
    >
      <template v-slot:empty>
        <p class="text-center">No past events.</p>
      </template>
    </event-cards>
  </v-card>
</template>

<script>
import moment from 'moment'
import EventCards from '@/components/EventCards'
import MailingList from '@/components/MailingList'
import MetaInfoBuilder from '@/utils/social'
import { EventDoc } from '@/utils/types'
import {
  VCard
} from 'vuetify/lib'

export default {
  components: {
    VCard,
    EventCards,
    MailingList,
  },
  computed: {
    current() {
      return [...this.events, ...this.extra]
        .filter((event) => {
          if (!event.endAt) {
            return true
          }
          return moment()
            .isSameOrBefore(moment(event.endAt.toDate()))
        })
    },
    past() {
      return [...this.events, ...this.extra]
        .filter((event) => {
          if (!event.endAt) {
            return true
          }
          return moment()
            .isAfter(moment(event.endAt.toDate()))
        })
    },
  },
  data: () => ({
    events: [],
    loading: true,
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .title(this.title)
      .build()
  },
  mounted() {
    let collection = EventDoc.Collection
        .orderBy('createdAt', 'desc')
        .where('archived', '==', false)
        .where('published', '==', true)

    if (this.types.length > 0) {
      collection = collection.where('type', 'in', this.types)
    }

    this.$bind('events', collection)
      .then(() => this.loading = false)
  },
  props: {
    extra: {
      default() {
        return []
      },
      type: Array
    },
    title: String,
    types: {
      default() {
        return []
      },
      type: Array,
    },
  },
}
</script>
